export type SourceCodeIntegrationLike = {
  repositories?: ReadonlyArray<unknown> | null;
};

export function hasSourceCode({
  gitIntegrations,
}: {
  gitIntegrations: ReadonlyArray<SourceCodeIntegrationLike> | null | undefined;
}): boolean {
  return (gitIntegrations ?? []).some(
    (integration) => (integration.repositories?.length ?? 0) > 0,
  );
}

export function isBlackBox({
  gitIntegrations,
}: {
  gitIntegrations: ReadonlyArray<SourceCodeIntegrationLike> | null | undefined;
}): boolean {
  return !hasSourceCode({ gitIntegrations });
}

export function hasSourceCodeAmongApps({
  apps,
}: {
  apps: ReadonlyArray<
    | {
        gitIntegrations?: ReadonlyArray<SourceCodeIntegrationLike> | null;
      }
    | null
    | undefined
  >;
}): boolean {
  return apps.some((app) =>
    hasSourceCode({ gitIntegrations: app?.gitIntegrations }),
  );
}

export function shouldOfferConnectSourceCode(value: {
  hasSourceCode: boolean;
  onConnectSourceCode?: (() => void) | undefined;
}): value is {
  hasSourceCode: boolean;
  onConnectSourceCode: () => void;
} {
  return !value.hasSourceCode && value.onConnectSourceCode !== undefined;
}
